<template>
  <div id="app" class="app-shell">
    <app-header />
    <transition name="site-loading-fade">
      <div v-if="requestLoading.visible" class="site-loading-mask" aria-live="polite" aria-label="页面加载中">
        <div class="site-loading-card">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
      </div>
    </transition>
    <router-view />
    <app-footer />
    <el-backtop :right="24" :bottom="24" />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import { requestLoadingState } from "./utils/requestLoading";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      requestLoading: requestLoadingState
    };
  }
};
</script>

<style lang="less">
.app-shell {
  min-height: 100vh;
  background:
    radial-gradient(circle at 12% 16%, rgba(32, 184, 218, 0.14), transparent 28%),
    linear-gradient(180deg, #061e3b 0, #0a3568 460px, #eaf4ff 1020px, #f7fbff 100%);
}

.site-loading-mask {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: grid;
  place-items: center;
  background: rgba(4, 26, 53, 0.28);
  backdrop-filter: blur(2px);
}

.site-loading-card {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 0 18px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  color: var(--navy);
  box-shadow: 0 18px 44px rgba(4, 26, 53, 0.18);
  font-size: 14px;
  font-weight: 800;
}

.site-loading-card i {
  color: var(--blue);
  font-size: 18px;
}

.site-loading-fade-enter-active,
.site-loading-fade-leave-active {
  transition: opacity 0.18s ease;
}

.site-loading-fade-enter,
.site-loading-fade-leave-to {
  opacity: 0;
}
</style>
